// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-catalog-index-categories-ysyzy{display:grid}.pages-catalog-index-categories-ysyzy.pages-catalog-index-desktop-flzos{grid-gap:48px;grid-template-columns:repeat(5,1fr)}.pages-catalog-index-categories-ysyzy.pages-catalog-index-mobile-bwupu{grid-gap:12px;grid-template-columns:repeat(2,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categories": "pages-catalog-index-categories-ysyzy",
	"desktop": "pages-catalog-index-desktop-flzos",
	"mobile": "pages-catalog-index-mobile-bwupu"
};
module.exports = ___CSS_LOADER_EXPORT___;
